import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';





export class ChapterForty extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="To judge the state of a tech startup ecosystem, look at the money. Over the past five years, the number of venture deals in SEA has risen at all stages from angel and seed to late stage funding. Significantly, large funds are now available to finance later stage deals. For example, in 2017, Tokopedia’s $1.1 billion Series F and Grab’s $2 billion Series G funding were worth more than all of that year’s other deals combined." />
        <TextHolder text="The flow of funding over the past five years shows that SEA has a vibrant tech startup ecosystem. From 2013 to 2018, there were 1,412 investments totaling about $11 billion. Singapore received the most funding of any city or nation in SEA; it is also where most of the region’s VC funds are held. Vietnam is the minnow of the region, with the least funding and lowest number of deals." />
        <TextHolder text="Seed rounds represented more than half of all venture deals in 2017, and more than 65 percent of deals were for less than $2 million." />

        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/40.js